import { render, staticRenderFns } from "./CredenciamentoImpugnacaoTabela.vue?vue&type=template&id=51713bbe&scoped=true"
import script from "./CredenciamentoImpugnacaoTabela.vue?vue&type=script&lang=js"
export * from "./CredenciamentoImpugnacaoTabela.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoImpugnacaoTabela.vue?vue&type=style&index=0&id=51713bbe&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51713bbe",
  null
  
)

export default component.exports